import axios from 'axios'

const state = {
  allComments: {}
}

const getters = {
  getAllComments: state => state.allComments,
  getComment: state => (type, id = 0) => state.allComments[type] !== undefined ? (state.allComments[type][id] ?? {}) : {}
}

const actions = {
  async fetchComments ({ commit }, { type = null, id = 0 } = {}) {
    let axiosLink = `/api/comments`
    if (type) {
      axiosLink += `/${type}`
    }
    if (id) {
      axiosLink += `/${id}`
    }
    await axios({
      method: 'get',
      url: axiosLink,
      headers: {
        Authorization: 'Bearer' + this.getters.getAccessToken
      }
    })
      .then(response => {
        for (const i in response.data) {
          const item = response.data[i]
          commit('SET_COMMENTS', { data: item, type: item.entity_type, id: item.entity_id })
        }
      })
      .catch(console.error)
  },
  async setComment ({ commit }, { type, id, comment }) {
    await axios({
      method: 'post',
      url: `/api/comments/${type}/${id}`,
      data: {
        comment
      },
      headers: {
        Authorization: 'Bearer' + this.getters.getAccessToken
      }
    })
      .then(response => {
        commit('SET_COMMENTS', { data: (response.data ? response.data : response), type, id })
      })
      .catch(console.error)
  }
}

const mutations = {
  SET_COMMENTS (state, { data = {}, type, id = 0 }) {
    state.allComments[type] = state.allComments[type] ?? {}
    state.allComments[type][id] = data
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
